// External Modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

// Internal Modules
import { DatePickerModule } from 'src/app/modules/date-picker/date-picker.module';
import { NgxMapModule } from 'src/app/modules/ngx-map/ngx-map.module';
import { DateConditionModule } from 'src/app/modules/date-condition/date-condition.module';
import { SharedModule } from 'src/app/modules/shared/shared.module';

// Components
import { DemandComponent } from './demand.component';
import { DemandOverviewTableComponent } from './components/demand-overview-table/demand-overview-table.component';


@NgModule({
  declarations: [
    DemandComponent,
    DemandOverviewTableComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild([{ path: 'demand', component: DemandComponent }]),
    DatePickerModule,
    NgxMapModule,
    DateConditionModule,
    NgbModule,
    SharedModule
  ]
})
export class DemandModule { }
